export const QUIZES_LOAD = '@quizes/load';
export const QUIZES_OPEN = '@quizes/open';
export const QUIZES_ADD_POINTS = '@quizes/add-points';
export const QUIZES_CALCULATE = '@quizes/calculate';
